module.exports = __webpack_public_path__ + "assets/media/3.21436e31.wav";